import { createSlice } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

/**
 * @typedef {Object} ReduxTrainingState
 * @property {boolean} reload - Bandera que alterna su valor para forzar recargas.
 * @property {boolean} reloadCourses - Bandera que alterna su valor para forzar recargas.
 * @property {number|null} cursoColaboradorId - ID del curso asignado al colaborador actual. Puede ser `null` si no hay ninguno seleccionado.
 * @property {any} cursosActions - Objeto, función u otro tipo de valor con las acciones del curso. Puede ser `null`.
 */
const initialState = {
	reload: true,
	reloadCourses: true,
	cursoColaboradorId: null,
	cursosActions:null,
	openPdf: false,
	edit:null,
	expanded:null
}
const TrainingSlice = createSlice({
	name: "training",
	initialState,
	reducers: {
		Reload(state) {
			state.reload = !state.reload
		},
		Edit(state,action) {
			state.edit = action.payload
		},
		SetExpanded(state,action) {
			state.expanded = action.payload
		},
		ReloadCourses(state) {
			state.reloadCourses = !state.reloadCourses
		},
		SetCursoColaboradorId(state, action) {
			state.cursoColaboradorId = action.payload
		},
		SetCursosActions(state, action) {
			state.cursosActions = action.payload
		},
		SetOpenPdf(state, action) {
			state.openPdf = action.payload
		},
	},
})

export default TrainingSlice
/**
 * Hook que permite acceder al estado global de `training` desde Redux.
 *
 * @returns {ReduxTrainingState} Estado actual del slice `training`.
 *
 * @example
 * const { reload, cursoColaboradorId, cursosActions } = UseReduxTraining();
 */
export const UseReduxTraining = () => {
	return useSelector((state) => state.training)
}
